import React from "react";
export default class LoaderTicket extends React.Component {
  render() {
    const { Bs, VARIANT, SIZE, _icon } = this.props;
    return (
      <>
        <Bs row className="mb-2">
          <Bs card bg={VARIANT.WHITE} className="lb-secondary-3">
            <Bs cardbody>
              <Bs row>
                <Bs col xs={2}>
                  <Bs placeholder animation="glow">
                    <Bs placeholder xs={12} />
                  </Bs>
                </Bs>
                <Bs col xs={2}>
                  <Bs placeholder animation="glow">
                    <Bs placeholder xs={12} />
                  </Bs>
                </Bs>
                <Bs col xs={2}>
                  <Bs placeholder animation="glow">
                    <Bs placeholder xs={12} />
                  </Bs>
                </Bs>
                <Bs col xs={1}>
                  <Bs placeholder animation="glow">
                    <Bs
                      placeholderbutton
                      xs={4}
                      variant={VARIANT.SECONDARY}
                      size={SIZE.SM}
                      aria-hidden="true"
                    />
                  </Bs>
                </Bs>
                <Bs col xs={2}></Bs>
                <Bs col xs={1}>
                  <Bs placeholder animation="glow">
                    <Bs
                      placeholderbutton
                      xs={4}
                      variant={VARIANT.SECONDARY}
                      size={SIZE.SM}
                      aria-hidden="true"
                    />
                  </Bs>
                </Bs>
                <Bs col xs={1}>
                  <Bs placeholder animation="glow">
                    <Bs
                      placeholderbutton
                      xs={4}
                      variant={VARIANT.SECONDARY}
                      size={SIZE.SM}
                      aria-hidden="true"
                    />
                  </Bs>
                </Bs>
                <Bs col xs={1}>
                  <Bs placeholder animation="glow">
                    <Bs
                      placeholderbutton
                      xs={4}
                      variant={VARIANT.SECONDARY}
                      size={SIZE.SM}
                      aria-hidden="true"
                    />
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
      </>
    );
  }
}
